import * as React from "react";
import { PairValue } from "types";
import { Custom } from "components";
import { useApp } from "context";
import {
  Autocomplete as MUIAutocomplete,
  Chip,
  TextField,
} from "@mui/material";

// TODO: in this files three lines type declaration are replaced with "any" type, becuase when "multiple" prop changes these types also change. needs change!!
export type Props = {
  sx?: any;
  name?: string;
  label?: string;
  limitTags?: number;
  multiple?: boolean;
  placeholder?: string;
  items: PairValue[];
  // value?: PairValue[];
  value?: any;
  onChange?: (
    event: React.SyntheticEvent<Element, Event>,
    // value: PairValue[] | null
    value: any
  ) => void;
};

export const Autocomplete = (props: Props) => {
  const { t, theme } = useApp();

  return (
    <MUIAutocomplete
      multiple={!!props.multiple}
      // onChange={(e: React.SyntheticEvent<Element, Event>, items: PairValue[]) =>
      onChange={(e: React.SyntheticEvent<Element, Event>, items: any) =>
        props.onChange && props.onChange(e, items)
      }
      noOptionsText={t.message.placeholder.no_option}
      options={props.items.map((item: PairValue) => item)}
      getOptionLabel={(option: PairValue) => option.value}
      // TODO: defaultValue is changed to value. Is that OK?
      value={props.value}
      renderTags={(value, getTagProps) =>
        value.map((option: PairValue, index: number) => (
          <Custom.Chip
            label={option.value}
            sx={{
              backgroundColor: theme.palette.background.accent,
            }}
            {...getTagProps({ index })}
          />
        ))
      }
      renderInput={(params) => (
        <TextField
          sx={{
            width: "100%",
            backgroundColor: theme.palette.background.color,
            "& label": {
              color: theme.palette.font.color,
            },
            "& .MuiTextField-root": {
              backgroundColor: theme.palette.background.color,
              "&:hover": {
                backgroundColor: theme.palette.background.color,
              },
            },
            "& .MuiInputBase-root": {
              backgroundColor: theme.palette.background.color,
              "&:focused": {
                backgroundColor: theme.palette.background.color,
              },
            },
            "& .MuiInputBase-input": {
              color: theme.palette.background.text,
              borderRadius: theme.border.radius / 4,
              backgroundColor: theme.palette.background.color,
              borderBottomWidth: 2,
              borderBottomStyle: "solid",
              borderBottomColor: theme.palette.background.color,
              borderBottomLeftRadius: 0,
              borderBottomRightRadius: 0,
              "&:focus": {
                borderBottomColor: theme.color.primary.color,
              },
            },
            "& .MuiInputBase-inputMultiline": {
              color: theme.palette.font.color,
            },
            "& input": {
              color: theme.palette.font.color,
            },
            "& .Mui-disabled": {
              color: theme.color.disabled.color,
              backgroundColor: theme.palette.background.color,
              WebkitTextFillColor: theme.color.disabled.color,
            },
            "& .MuiAutocomplete-clearIndicator, & .MuiAutocomplete-popupIndicator":
              {
                color: theme.palette.font.color,
              },
          }}
          {...params}
          variant="filled"
          name={props.name}
          label={props.label}
          placeholder={props.placeholder}
        />
      )}
    />
  );
};
